// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"640":"97a1f66f","657":"28f491fe","669":"8b0f5e79","737":"824bdcf8","755":"97a1f66f","901":"97a1f66f","918":"97a1f66f"}[chunkId] + ".css";
};